import React from 'react'
// libs
import styled from 'styled-components'
import { reduxForm } from 'redux-form'
// components
import { Button, BUTTON_LAYOUTS, Scrollbar } from 'components/UI'
// constants
import { Forms } from 'constants/forms'
// themes
import Grid from '@mui/material/Grid2'
import { ActionsWrapper, Content } from 'themes/views/modals'
// utils
import { generateFields } from 'utils/fields'

const Form = styled('form')`
  height: calc(100vh - 263px);

  ${Scrollbar} {
    height: calc(100% - 62px);
  }

  > div:last-child {
    padding: 10px 20px;
  }
`

const AddResourceForm = ({ canModify, fields, form, handleSubmit, hideModal, valid }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Scrollbar>
        <Content>
          <Grid container direction={'column'} spacing={2} wrap={'nowrap'}>
            {fields.map((field) => generateFields({ field, form, canModify }))}
          </Grid>
        </Content>
      </Scrollbar>
      <ActionsWrapper>
        <Button disabled={!canModify || !valid} shadowLess layout={BUTTON_LAYOUTS.PURPLE} type={'submit'}>
          Save
        </Button>
        <Button disabled={!canModify} shadowLess layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={hideModal}>
          Cancel
        </Button>
      </ActionsWrapper>
    </Form>
  )
}

export default reduxForm({
  form: Forms.RESOURCE_CREATE_FORM,
  enableReinitialize: true
})(AddResourceForm)
